(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300),
      );
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    function updateCheckoutButton() {
      const checkoutButton = document.querySelector(".cart-checkout-button");
      if (!checkoutButton) {
        console.warn("⚠️ Checkout button not found!");
        return;
      }

      const cartTotalElement = document.querySelector("[data-cart-subtotal]");
      if (!cartTotalElement) {
        console.warn("⚠️ Cart subtotal not found!");
        return;
      }

      const cartTotal = parseFloat(cartTotalElement.textContent.replace(/[^\d.]/g, "")) || 0;
      console.log("🛒 Cart Total:", cartTotal);

      if (cartTotal < 2000) {
        checkoutButton.setAttribute("disabled", "disabled");
        checkoutButton.classList.add("button-disabled");
      } else {
        checkoutButton.removeAttribute("disabled");
        checkoutButton.classList.remove("button-disabled");
      }
    }

    // Run once on page load
    updateCheckoutButton();

    // Shopify cart update event
    document.addEventListener("cart:updated", () => {
      console.log("🔄 Cart updated event fired");
      updateCheckoutButton();
    });

    // Use MutationObserver to detect cart subtotal changes
    const cartSubtotalElement = document.querySelector("[data-cart-subtotal]");
    if (cartSubtotalElement) {
      const subtotalObserver = new MutationObserver(() => {
        console.log("🔄 Cart subtotal changed");
        updateCheckoutButton();
      });

      subtotalObserver.observe(cartSubtotalElement, { childList: true, subtree: true });
    } else {
      console.warn("⚠️ Cart subtotal element not found for observation.");
    }

    // Fallback: Observe changes in the cart container
    const cartContainer = document.querySelector("#main-cart-footer");
    if (cartContainer) {
      const cartObserver = new MutationObserver(() => {
        console.log("🔄 Cart updated via MutationObserver");
        updateCheckoutButton();
      });

      cartObserver.observe(cartContainer, { childList: true, subtree: true });
    } else {
      console.warn("⚠️ Cart container not found for observation.");
    }
  });

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
